<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Lista Cotizaciones</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/turismo/cotizaciones/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear cotización </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light btn-sm" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>Código</th>
                  <th>Usuario</th>
                  <th>Identificador</th>
                  <th>Nombre packete</th>
                  <th>Tipo paquete</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <span class="pointer" style="font-weight: bold; color:green" (click)="edit(item.id)">
                        {{item.code}}
                      </span>
                    </td>
                    <td>{{item.username}}</td>
                    <td>{{item.identifier_cotization}}</td>
                    <td>{{item.description}}</td>
                    <td>{{item.typepackage.description}}</td>
                    <td class="text-center">
                      <a class="btn p-5 pointer text-danger bold" (click)="delete(item, i)">
                        <i class="far fa-trash-alt"></i>
                      </a>
                      <a class="btn p-5 pointer text-success bold" (click)="edit(item.id)">
                        <i class="fas fa-pencil-alt"></i>
                      </a>
                      <a class="btn p-5 pointer bold" style="color: rgb(241, 16, 143)" target="_blank"
                        href="/{{branchofficeSlug}}/api/cotizacion/descargar/pdf/{{item.id}}">
                        <i class="far fa-file-pdf"></i>
                      </a>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
